/* eslint-disable  */
import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@mui/x-data-grid';
import {
    Grid, Button, Menu, MenuItem, IconButton, Dialog, DialogContent
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import Form from './Form';
import { Typography } from '@material-ui/core';
import { useTitles, useCreateTitle, useUpdateTitle, useDeleteTitle } from '~/titles';
import Swal from '#/swal';


const useStyles = makeStyles({
    dataGrid: {
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
            outline: 'none'
        }
    },
    tableWrapper: {
        width: '100%'
    },
    redButton: {
        color: '#fff',
        backgroundColor: '#DB2828'
    }
});

const TitleList = props => {

    const classes = useStyles();
    const { data: titles, isLoading } = useTitles();
    const { mutate: deleteTitle, error: onDeleteTitleError } = useDeleteTitle();
    const { mutate: createTitle, error: onCreateTitleError } = useCreateTitle();
    const { mutate: updateTitle, error: onUpdateTitleError } = useUpdateTitle();
    const [modalOpen, setModalOpen] = useState(false);
    const [initialValues, setInitialValues] = useState(null);

    //State for action button
        const [actions, setActions] = useState(null);

    //State for table row
        const [rowSelected, setRowSelected] = useState();

    const onSubmit = values => {
        if (initialValues) {
            updateTitle({
                id: values.id,
                payload: values
            });
        }
        else {
            createTitle(values);
        }
        setModalOpen(false);   
    };


    // Handle to delete Job Title
    const handleDelete = async id => {
        const { value } = await Swal.fire.warning({ text: `Are you sure you want to delete this Title?` });

        if (value) deleteTitle(id);

    };

    const handleErrorDeleteTitle = useCallback(async () => {
        await Swal.fire({ text: `Job Title can't be deleted. One or more employees belong to this group. Reassign them and try again.`, icon: 'error' });
    }, [])
    
    useEffect(() => {

        if (onDeleteTitleError) {
            handleErrorDeleteTitle()
        }

    }, [onDeleteTitleError])

    // Popover settings.

    const openPopover = (event, row) => {

        // console.log('rieie', row)
        setRowSelected(row)
        setActions(event.currentTarget);
    };

    const closePopover = () => {
        setActions(null);
    };
    const moreActions = Boolean(actions);


    //Columns setup and fetching data.

    const columns = useMemo(() => [
        {
            field: 'title',
            renderHeader: () => <strong> Job Title</strong>,
            flex: 1,
            renderCell: ({ row }) => <div> {row.name} </div>
        },
        {
            field: 'description',
            renderHeader: () => <strong> Job Description</strong>,
            flex: 1,
            renderCell: ({ row }) => {
                <div> {row.description} </div>
            }
        },
        {
            field: 'more',
            align: 'right',
            headerAlign: 'right',
            renderHeader: () => <strong>Actions</strong>,
            renderCell: ({ row }) => (
                <div>
                    <IconButton
                        onClick={e => openPopover(e, row)}>
                        <MoreVert />
                    </IconButton>
                </div>
            ),
            flex: .2
        }
    ])

    return (
        <div>
            <Grid container justifyContent='space-between' style={
                {
                    marginBottom: '20px',
                    marginTop: '20px'
                }}>
                <Grid>
                    <Typography variant='h4' children='Job Titles' />
                </Grid>

                <Grid item>
                    <Button
                        children='New Job Title'
                        variant='contained'
                        color='primary'
                        onClick={() => {
                            setInitialValues(null);
                            setModalOpen(true);
                        }}
                    />
                </Grid>
            </Grid>

            <div className={classes.tableWrapper}>
                <DataGrid
                    className={classes.dataGrid}
                    loading={isLoading}
                    columns={columns}
                    rows={titles || []}
                    autoHeight
                    disableSelectionOnClick
                    hideFooterSelectedRowCount
                />
                <div>
                    <Menu
                        id='actions'
                        open={moreActions}
                        anchorEl={actions}
                        onClose={closePopover}
                        onClickCapture={closePopover}
                        >
                        <MenuItem onClick={() => {
                            setInitialValues(rowSelected);
                            setModalOpen(true);
                        }}>
                            Edit
                        </MenuItem>
                        <MenuItem onClick={() => handleDelete(rowSelected.id)}>
                            Delete
                        </MenuItem>
                        <MenuItem onClick={() => props.history.push(`/titles/${rowSelected.id}/employees`)}>
                            View Employees
                        </MenuItem>
                        <MenuItem onClick={() => props.history.push(`/titles/${rowSelected.id}/eval-questions`)}>
                            Eval Questions
                        </MenuItem>
                    </Menu>
                </div>
            </div>

            <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
                <DialogContent>
                    <Form setModalOpen={setModalOpen} initialValues={initialValues} onSubmit={onSubmit} />
                </DialogContent>
            </Dialog>

        </div>
    );
};

export default TitleList;